export default __webpack_public_path__ + "static/media/b1.28b67d41.png";